import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.ReviewerV1SupportingBanner', {
    title: 'The old Reviewer feature for Xero bills will be removed on <b>1 July 2025</b>.',
    text: 'To retain review and editing functionality, please migrate to the more flexible and powerful <b>Editing on Approval</b> feature.',
    learnMore: 'Learn more',
});
